import { render, staticRenderFns } from "./ResourceAdviceOverlay.vue?vue&type=template&id=585cf464&scoped=true"
import script from "./ResourceAdviceOverlay.vue?vue&type=script&lang=js"
export * from "./ResourceAdviceOverlay.vue?vue&type=script&lang=js"
import style0 from "./ResourceAdviceOverlay.vue?vue&type=style&index=0&id=585cf464&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585cf464",
  null
  
)

export default component.exports